import {
  Component,
  OnDestroy,
  ViewChild,
  OnInit,
  ViewContainerRef,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Member, TeamTexts } from "@/core/models";
import { Configuration } from "@/shared-module/models";

@Component({
  selector: "app-password-lost",
  templateUrl: "password-lost.component.html",
})
export class PasswordLostComponent implements OnDestroy, OnInit {
  @ViewChild("template", { static: true }) template;
  @Output() submitted: EventEmitter<any> = new EventEmitter();
  @Output() cancelled: EventEmitter<void> = new EventEmitter();
  @Input() data: Member;
  @Input() texts: TeamTexts;
  @Input() errorMessage: string;

  memberForm: FormGroup;
  subs = new SubSink();
  cssColor: string;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private configurationService: ConfigurationService,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
      },
    );
  }

  onSubmit() {
    this.memberForm.updateValueAndValidity();
    if (this.memberForm.valid) {
      this.submitted.emit(this.memberForm.value);
    }
  }

  cancel() {
    this.cancelled.emit();
  }

  get universityId() {
    return this.memberForm.get("universityId");
  }

  get email() {
    return this.memberForm.get("email");
  }

  atLeastOneValidator(group: FormGroup): any {
    if (group) {
      if (
        group.get("universityId").value === "" &&
        group.get("email").value === ""
      ) {
        return { atLeastOneIsRequired: true };
      }
    }
    return null;
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);

    this.memberForm = new FormGroup({
      universityId: new FormControl(""),
      email: new FormControl("", [Validators.email]),
    });

    this.memberForm.setValidators(this.atLeastOneValidator);
    this.memberForm.updateValueAndValidity();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
